import PhoenixDocCard from 'components/base/PhoenixDocCard';
import { Col, Row } from 'react-bootstrap';
import services from 'assets/img/spot-illustrations/services.png';
import ServiceList from 'pages/servicecampaignmanagement/ServiceList';

const ServiceManagement = () => {
  return (
    <div>
      <h2 className="mb-4 lh-sm">Service Management</h2>
      <PhoenixDocCard className="mb-4">
        <PhoenixDocCard.Header noPreview className="pb-2 pt-3">
          <Row>
            <Col className="d-flex justify-content-between align-items-center">
              <div>
                <h4 className="mb-2">
                  Services definition to organize your campaigns
                </h4>
                <p className="mb-0">
                  Services are an essential organizational tool in campaign
                  management, used to group campaigns in a structured manner
                  that facilitates filtering and management. They can represent
                  various categories such as final clients, departments, or
                  other classifications that help keep campaigns tidy and easily
                  accessible.
                  <br />
                  <br />
                  Using Services enhances management efficiency by allowing for
                  better oversight and strategic decision-making. By associating
                  campaigns with specific Services, users can quickly filter and
                  locate campaigns relevant.
                </p>
              </div>
            </Col>
            <Col xs="auto" className="order-xxl-2">
              <div className="x-6">
                <img src={services} alt="" />
              </div>
            </Col>
          </Row>
        </PhoenixDocCard.Header>
        <PhoenixDocCard.Body>
          <div className="px-4">
            <ServiceList />
          </div>
        </PhoenixDocCard.Body>
      </PhoenixDocCard>
    </div>
  );
};

export default ServiceManagement;
